import { Camera } from 'expo-camera';

export const checkCameraPermission = async () => {
  const cameraPermission = await Camera.getCameraPermissionsAsync();

  if (!cameraPermission.granted) {
    const askPermission = await Camera.requestCameraPermissionsAsync();
    return askPermission;
  } else {
    return cameraPermission;
  }
};
